import {Image, useProductOptions} from '@shopify/hydrogen';
import clsx from 'clsx';

//types
import type {ProductVariant} from '@shopify/hydrogen/storefront-api-types';

export default function ProductDetailsOptionsGeneric({
  name,
  values,
  availableVariants,
}: {
  name: string;
  values: string[];
  availableVariants: ProductVariant[] | undefined;
}) {
  const {setSelectedOption, selectedOptions} = useProductOptions();

  const handleChange = (optionName: string, optionValue: string) => {
    if (setSelectedOption) {
      setSelectedOption(optionName, optionValue);
    }
  };

  return (
    <fieldset key={name} className="my-2">
      <ul className="grid grid-cols-3 gap-1">
        {values.map((value, index) => {
          const checked = selectedOptions?.[name] === value;
          const id = `option-${name}-${value}`;
          const optionIsAvailable = availableVariants?.find(
            (v) => v.title === value,
          );

          return (
            <li
              key={`${id}-${index}`}
              className={clsx([
                'product-variant group cursor-pointer overflow-hidden rounded-full border-[1px] border-solid border-slate-200',
                optionIsAvailable ? '' : 'pointer-events-none opacity-25',
                checked && 'border-2 !border-black',
              ])}
            >
              <button
                className="block w-full overflow-hidden p-1.5"
                title={optionIsAvailable ? value : 'Out of Stock'}
              >
                <label key={id} htmlFor={id} className="pointer-events-none">
                  <input
                    className="sr-only"
                    type="radio"
                    id={id}
                    name={`option[${name}]`}
                    value={value}
                    checked={checked}
                    onChange={() => handleChange(name, value)}
                  />
                  <div className="flex items-center justify-center text-center">
                    <span className="text-[10px]">{value}</span>
                  </div>
                </label>
              </button>
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
}
